// extracted by mini-css-extract-plugin
export default {"div":"Footer_div__a63vz","content":"Footer_content__gvdwq","links":"Footer_links__OtNYy","column":"Footer_column__vAxIQ"};